import { render, staticRenderFns } from "./InvoicesReadOnly.vue?vue&type=template&id=41c27b16"
import script from "./InvoicesReadOnly.vue?vue&type=script&lang=js"
export * from "./InvoicesReadOnly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports